export const createErrorMessage = (e: Error, defaultMessage: string) => {
  if (e.message.match(/PERMISSION_DENIED/)) {
    return defaultMessage;
  } else {
    return e.message;
  }
};
